"use client";

import Script from "next/script";

interface GoogleAnalyticsScriptProps {
  gaId: string;
  debugMode?: boolean;
}

export function GoogleAnalyticsScript({
  gaId,
}: GoogleAnalyticsScriptProps): React.ReactElement | null {
  if (!gaId) return null;

  return (
    <>
      <Script id="ga4-consent-init" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){window.dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('consent', 'default', {
            ad_storage:          'denied',
            ad_user_data:        'denied',
            ad_personalization:  'denied',
            analytics_storage:   'granted',
            wait_for_update:     500
          });

          gtag('config', '${gaId}', { send_page_view: false });
        `}
      </Script>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
        strategy="afterInteractive"
        onLoad={() => {
          (window as any).__gtagReady = true;
          window.dispatchEvent(new Event('gtag:ready'));
        }}
      />
    </>
  );
}
